import { put, all, takeLatest } from 'redux-saga/effects';
import { handleApiCall } from './SagaUtils';
import { push } from 'react-router-redux';

import AccountGroupsSaga from './entities/AccountGroupsSaga';
import UsersSaga from './entities/UsersSaga';
import TeamsSaga from './entities/TeamsSaga';

import {
  FETCH_OPPORTUNITIES,
  FETCH_OPPORTUNITY,
  FETCH_COMPANIES,
  FETCH_COMPANY,
  UPDATE_COMPANY,
  CREATE_COMPANY,
  DELETE_COMPANY,
  FETCH_RESULTS,
  FETCH_RESULT,
  FETCH_GAME_EVENTS,
  FETCH_CHATS_STATS,
  FETCH_CHAT_STATS,
  FETCH_GAME_CONVERSATIONS,
  IMPERSONATE_DASHBOARD_USER,
} from '../constants/Constants';
import * as Api from '../services/Api';

function* fetchOpportunities() {
  yield handleApiCall(FETCH_OPPORTUNITIES, Api.fetchOpportunities, true);
}

function* fetchOpportunity({ payload: { postId } }) {
  yield handleApiCall(FETCH_OPPORTUNITY, Api.fetchOpportunity, true, postId);
}

function* fetchCompanies() {
  yield handleApiCall(FETCH_COMPANIES, Api.fetchCompanies, true);
}

function* fetchCompany({ payload: { companyId } }) {
  yield handleApiCall(FETCH_COMPANY, Api.fetchCompany, true, companyId);
}

function* deleteCompany({ payload: { companyId } }) {
  yield handleApiCall(DELETE_COMPANY, Api.deleteCompany, true, companyId);
  yield put(push('/settings/companies'));
}

function* updateCompany({ payload: { data, sendEmail } }) {
  yield handleApiCall(UPDATE_COMPANY, Api.updateCompany, true, data, sendEmail);
}

function* createCompany({ payload }) {
  yield handleApiCall(CREATE_COMPANY, Api.createCompany, true, payload);
  yield put(push('/settings/companies'));
}

function* fetchResults({ payload: { pagination, filter, additionalQuery } }) {
  yield handleApiCall(FETCH_RESULTS, Api.fetchResults, true, pagination, filter, additionalQuery);
}

function* fetchResult({ payload: { projectId, id, gameId } }) {
  yield all([
    yield handleApiCall(FETCH_RESULT, Api.fetchResult, true, projectId, id),
    yield fetchGameEvents({ payload: { gameId } }),
    yield fetchGameConversations({ payload: { gameId } }),
  ]);
}

function* fetchGameEvents({ payload: { gameId } }) {
  yield handleApiCall(FETCH_GAME_EVENTS, Api.fetchGameEvents, true, gameId);
}

function* fetchGameConversations({ payload: { gameId } }) {
  yield handleApiCall(FETCH_GAME_CONVERSATIONS, Api.fetchGameConversations, true, gameId);
}

function* fetchChatsStats() {
  yield handleApiCall(FETCH_CHATS_STATS, Api.fetchChats, true);
}

function* fetchChatStats({ payload: { projectId, from, to } }) {
  yield handleApiCall(FETCH_CHAT_STATS, Api.fetchChatStats, true, projectId, from, to);
}

function* impersonateDashboardUserRequested({ payload: { userId } }) {
  yield handleApiCall(IMPERSONATE_DASHBOARD_USER, Api.impersonateUser, true, userId, 'DASHBOARD');
}

function impersonateDashboardUser({
  payload: {
    payload: { url },
  },
}) {
  setTimeout(() => {
    window.open(url, '_blank');
  }, 500);
}

export default function* entitiesSaga() {
  yield all([
    yield takeLatest(FETCH_OPPORTUNITIES.REQUESTED, fetchOpportunities),
    yield takeLatest(FETCH_OPPORTUNITY.REQUESTED, fetchOpportunity),
    yield takeLatest(FETCH_COMPANIES.REQUESTED, fetchCompanies),
    yield takeLatest(FETCH_COMPANY.REQUESTED, fetchCompany),
    yield takeLatest(DELETE_COMPANY.REQUESTED, deleteCompany),
    yield takeLatest(UPDATE_COMPANY.REQUESTED, updateCompany),
    yield takeLatest(CREATE_COMPANY.REQUESTED, createCompany),
    yield takeLatest(FETCH_RESULTS.REQUESTED, fetchResults),
    yield takeLatest(FETCH_RESULT.REQUESTED, fetchResult),
    yield takeLatest(FETCH_GAME_EVENTS.REQUESTED, fetchGameEvents),
    yield takeLatest(FETCH_GAME_CONVERSATIONS.REQUESTED, fetchGameConversations),
    yield takeLatest(FETCH_CHATS_STATS.REQUESTED, fetchChatsStats),
    yield takeLatest(FETCH_CHAT_STATS.REQUESTED, fetchChatStats),
    yield takeLatest(IMPERSONATE_DASHBOARD_USER.REQUESTED, impersonateDashboardUserRequested),
    yield takeLatest(IMPERSONATE_DASHBOARD_USER.SUCCESS, impersonateDashboardUser),
    ...AccountGroupsSaga(),
    ...UsersSaga(),
    ...TeamsSaga(),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/EntitiesSaga.js